import { render, staticRenderFns } from "./job-inactive.component.html?vue&type=template&id=0bc068ec&scoped=true&external"
import script from "./job-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./job-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-inactive.component.scss?vue&type=style&index=0&id=0bc068ec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc068ec",
  null
  
)

export default component.exports